var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8344 5.8344C5.63969 5.83478 5.45099 5.76696 5.30106 5.64273L0.301062 1.47606C-0.0533204 1.18151 -0.101823 0.655445 0.192729 0.301063C0.487281 -0.0533201 1.01335 -0.101823 1.36773 0.192729L5.8344 3.92606L10.3011 0.326064C10.4732 0.186256 10.694 0.12084 10.9145 0.144301C11.1351 0.167763 11.3372 0.278165 11.4761 0.451064C11.6303 0.624281 11.7054 0.853962 11.6833 1.08486C11.6612 1.31576 11.5438 1.52699 11.3594 1.66773L6.3594 5.69273C6.20516 5.79733 6.02031 5.84721 5.8344 5.8344Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.2942ec03ff0bb339b3e67e33ec3c440d.svg";
export { ForwardRef as ReactComponent };